/**
 * @param {ReactNode} children - Elementos adicionales que se pueden renderizar dentro del modal.
 * @param {boolean} isOpen - Indica si el modal está abierto o cerrado.
 * @param {Function} onClose - Función para cerrar el modal.
 * @param {Function} onConfirm - Función que se ejecuta cuando el usuario confirma la acción.
 * @param {string} mensaje - Mensaje que se muestra en el modal de confirmación.
 */
import Modal from './Modal'  
import Button from './../common/Button' 
const ModalConfirmacion = ({ children, isOpen, onClose, onConfirm, mensaje }) => {
    return (
        <Modal isOpen={isOpen} title="Confirmación" onClose={onClose}>
            {/* Mensaje principal del modal */}
            <p>{mensaje}</p>

            {/* Elementos adicionales que pueden ser pasados como children */}
            {children}

            {/* Contenedor de botones para acciones */}
            <div className="flex justify-end gap-4 mt-4">
                {/* Botón de confirmación, se dispara la función onConfirm */}
                <Button
                    onClick={onConfirm}
                    type="delete"  // Se asume que el botón tiene estilos para acciones de eliminación
                />

                {/* Botón para cancelar y cerrar el modal */}
                <Button
                    onClick={onClose}
                    texto="Cancelar"
                    type="cancel"  // Se asume que el botón tiene estilos para acciones de cancelación
                />
            </div>
        </Modal>
    )
}

export default ModalConfirmacion
